"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliverrError = void 0;
const ApiError_1 = require("./ApiError");
class DeliverrError extends Error {
    constructor(errorOptions) {
        if (isString(errorOptions)) {
            super(errorOptions);
            this.code = errorOptions;
            return;
        }
        else {
            const { code, subcode, functionName, payload, cause, silenceBugsnag } = errorOptions;
            super(getErrorMessage(errorOptions));
            this.code = code || ApiError_1.ApiError.UNKNOWN_ERROR;
            this.subcode = subcode;
            this.functionName = functionName;
            this.payload = payload;
            this.cause = cause;
            this.silenceBugsnag = silenceBugsnag;
        }
    }
}
exports.DeliverrError = DeliverrError;
function getErrorMessage(errorOptions) {
    const { code, subcode, message } = errorOptions;
    return message || (!code ? ApiError_1.ApiError.UNKNOWN_ERROR : subcode ? `${code}-${subcode}` : code);
}
function isString(x) {
    return Object.prototype.toString.call(x) === "[object String]";
}
//# sourceMappingURL=DeliverrError.js.map